import { render } from "./tasks-view.component.vue?vue&type=template&id=625e2ff3"
import script from "./tasks-view.component.vue?vue&type=script&lang=js"
export * from "./tasks-view.component.vue?vue&type=script&lang=js"

import "./tasks-view.component.vue?vue&type=style&index=0&id=625e2ff3&lang=css"

import exportComponent from "/mnt/ssd2/projects/techno2_remaster/client_ui/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__